// extracted by mini-css-extract-plugin
module.exports = {"contact":"bg_fq","contact__wrapper":"bg_fr","error__select":"bg_fs","error__input":"bg_ft"};